var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--hop-neutral-icon)",
  d: "M13.345 4.03c-.55-1.114-2.14-1.114-2.69 0L8.857 7.675l-4.02.584c-1.23.179-1.722 1.69-.832 2.559l2.91 2.835-.687 4.005c-.21 1.225 1.076 2.16 2.176 1.58L12 17.348l3.596 1.89c1.1.58 2.387-.355 2.176-1.58l-.686-4.005 2.909-2.835c.89-.868.399-2.38-.832-2.559l-4.02-.584-1.798-3.643Z"
})));
export default SvgIcon;